<template>
    <div class="content">
        <div class="tableTit">
            <p class="tabtitBg"></p>
            <h6>基本情况</h6>
        </div>
        <div class="tabBody">
            <el-table ref="multipleTable" @selection-change="handleSelectionChange" :height="tableHeight" :data="tabledata" border>
                <el-table-column type="index" align='center' width="45" label="序号" fixed="left"></el-table-column>
                <el-table-column prop="sheng" align='center' label="省"></el-table-column>
                <el-table-column prop="shi" align='center' label="市"></el-table-column>
                <el-table-column prop="xian" align='center' label="县"></el-table-column>
                <el-table-column prop="xiang" align='center' label="乡"></el-table-column>
                <el-table-column prop="cun" align='center' label="村"></el-table-column>
                <el-table-column prop="projectName" align='center' label="工程名称"></el-table-column>
                <el-table-column prop="cameraName" align='center' label="摄像头名称"></el-table-column>
                <el-table-column prop="cameraSubName" align='center' label="摄像头别名"></el-table-column>
                <el-table-column prop="cameraCode" align='center' label="摄像头编号"></el-table-column>
                <el-table-column align='center' label="地理坐标">
                    <el-table-column prop="jingDu" width="140" align='center' label="经度"></el-table-column>
                    <el-table-column prop="weiDu" width="140" align='center' label="纬度"></el-table-column>
                </el-table-column>
                <el-table-column prop="isExpire" align='center' label="是否到期">
                    <template slot-scope="scope">
                        <p v-if="scope.row.isExpire=='0'">否</p>
                        <p v-if="scope.row.isExpire=='1'">是</p>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="fye">
            <pagintion ref="mypagintion" @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums">
            </pagintion>
        </div>
    </div>
   
</template>

<script>
import pagintion from '@/components/mangement/pagintion.vue';
import {
    selectSheHeInfo
} from '@/api/api.js'


export default {
    data() {
        return {
            total: null,
            pageNums: null,
            tabledata: [],
            tableHeight: window.innerHeight - 180,
            multipleSelection: [],
            pageSize: 20, //每页多少条数据分页
            pageNum: 1 //当前页
        }
    },
    components: {
        pagintion,
    },
    mounted() {
        let params = {
            pageSize: this.pageSize,
            pageNum: this.pageNum
        }
        this.list(params)
    },
    methods:{
        list(params) {
            this.tabledata = [];
            selectSheHeInfo(params).then((res) => {
                console.log(res.data)
                this.tabledata = res.data;
                this.total = res.total;
                this.$refs.mypagintion.updateTotal(this.total);
            })
        },
        DsyData(data) { //多少页
            this.pageNum = data.dsy;
            let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            let requestParams = { ...params, ...this.condition };
            this.list(requestParams)
        },
        DstData(data) { //多少条
            this.pageSize = data.dst;
            this.pageNum = 1;
            let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            let requestParams = { ...params, ...this.condition };
            this.list(requestParams);
            this.$refs.mypagintion.updatePageNums(this.pageNums);
        },
        list(params) {
            selectSheHeInfo(params).then((res) => {
                this.tabledata = res.data;
                this.total = res.total;
            });
        },
        handleSelectionChange(val) {
        this.multipleSelection = val;
        },
        
    }
}
</script>